import React from 'react';
import { StyledLogo, StyledRateFormContainer, StyledX, StyledFeedbackTextarea, StyledButton } from './stars.style';
import { ReactComponent as FixelLogo } from './FixelLogo.svg';
import { ReactComponent as X } from './X.svg';

const BadRateForm = ({ onClose, onSubmit, feedback, setFeedback, sendRating }) => {
	return (
		<StyledRateFormContainer onSubmit={onSubmit}>
			<StyledX
				onClick={() => {
					sendRating();
					onClose();
				}}>
				<X />
			</StyledX>
			<StyledLogo>
				<FixelLogo />
			</StyledLogo>
			<h2>Help Us Get Better</h2>
			<h3>Please share what you want us to improve</h3>
			<StyledFeedbackTextarea autoFocus placeholder='Leave your feedback here...' onChange={(e) => setFeedback(e.target.value)} value={feedback} />
			<StyledButton type='submit' onClick={onClose}>
				Share Your Feedback
			</StyledButton>
		</StyledRateFormContainer>
	);
};
export default BadRateForm;
